import './tinymce/transparent_color_picker';
import './tinymce/formula_picker';
import './tinymce/upload_image';
import './tinymce/upload_audio';
import './tinymce/position';
import './tinymce/line';
import './tinymce/effects';
import './tinymce/lineheight';
import './tinymce/styles';
import './tinymce/store_item';
export { default as tinyMCEConfig } from './tinymce_config.js';
window.tinyMCE.baseURL = '/static/tinymce';
